import { useEffect } from "react";
import "@/App.css";
import { Navbar } from "@/components/portfolio/Navbar";
import { HeroSection } from "@/components/portfolio/HeroSection";
import { AboutSection } from "@/components/portfolio/AboutSection";
import { BuildAreasSection } from "@/components/portfolio/BuildAreasSection";
import { ProjectsSection } from "@/components/portfolio/ProjectsSection";
import { StackSection } from "@/components/portfolio/StackSection";
import { StoriesSection } from "@/components/portfolio/StoriesSection";
import { CommunitySection } from "@/components/portfolio/CommunitySection";
import { WorkStyleSection } from "@/components/portfolio/WorkStyleSection";
import { ContactSection } from "@/components/portfolio/ContactSection";
import { Footer } from "@/components/portfolio/Footer";
import { useReveal } from "@/hooks/useReveal";

function App() {
    // Initialise theme on first paint to avoid FOUC
    useEffect(() => {
        const stored = localStorage.getItem("vichu-theme") || "dark";
        document.documentElement.classList.remove("light", "dark");
        document.documentElement.classList.add(stored);
        document.title = "Vichu — Software Engineer, Tinkerer & Builder";
    }, []);

    useReveal();

    return (
        <div className="App relative min-h-screen bg-[var(--ink-bg)] text-[var(--ink-text-primary)]">
            <Navbar />
            <main>
                <HeroSection />
                <AboutSection />
                <BuildAreasSection />
                <ProjectsSection />
                <StackSection />
                <StoriesSection />
                <CommunitySection />
                <WorkStyleSection />
                <ContactSection />
            </main>
            <Footer />
        </div>
    );
}

export default App;
